<template>
  <section class="section_call">
    <div class="container_main_text_call">
      <div class="box_main_text_call">
        <h2 class="title_call">
          ВЫЗВАТЬ СПЕЦИАЛИСТА НА<br />
          ЗАМЕР?
        </h2>
        <h3 class="sub_title_call">
          ОСТАВЬТЕ ЗАЯВКУ И МЫ СВЯЖЕМСЯ С<br />
          ВАМИ В ТЕЧЕНИИ 15 МИНУТ
        </h3>
      </div>
      <div class="container_sub_text_call_mobil">
        <p class="sub_text_call">
          К вам приедет опытный замерщик, который:
        </p>
        <div class="container_check_mark_call">
          <div class="box_check_mark_call">
            <img src="@/assets/img/icon/check_mark.svg" class="check_mark" />
            <p class="text_check_mark">Сделает точный замер</p>
          </div>
          <div class="box_check_mark_call">
            <img src="@/assets/img/icon/check_mark.svg" class="check_mark" />
            <p class="text_check_mark">
              Проконсультирует по видам работ и этапам
            </p>
          </div>
          <div class="box_check_mark_call">
            <img src="@/assets/img/icon/check_mark.svg" class="check_mark" />
            <p class="text_check_mark">Подскажет по выбору материалов</p>
          </div>
          <div class="box_check_mark_call">
            <img src="@/assets/img/icon/check_mark.svg" class="check_mark" />
            <p class="text_check_mark">Сориентирует по стоимости и срокам</p>
          </div>
        </div>
      </div>
      <PhoneUi />
    </div>
    <div class="container_sub_text_call">
      <p class="sub_text_call">
        К вам приедет опытный замерщик, который:
      </p>
      <div class="container_check_mark_call">
        <div class="box_check_mark_call">
          <img src="@/assets/img/icon/check_mark.svg" class="check_mark" />
          <p class="text_check_mark">Сделает точный замер</p>
        </div>
        <div class="box_check_mark_call">
          <img src="@/assets/img/icon/check_mark.svg" class="check_mark" />
          <p class="text_check_mark">
            Проконсультирует по видам работ и этапам
          </p>
        </div>
        <div class="box_check_mark_call">
          <img src="@/assets/img/icon/check_mark.svg" class="check_mark" />
          <p class="text_check_mark">Подскажет по выбору материалов</p>
        </div>
        <div class="box_check_mark_call">
          <img src="@/assets/img/icon/check_mark.svg" class="check_mark" />
          <p class="text_check_mark">Сориентирует по стоимости и срокам</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import PhoneUi from "./ui/PhoneUi.vue";

export default {
  components: {
    PhoneUi,
  },
};
</script>
<style scoped>
.container_sub_text_call_mobil {
  display: none;
}
.section_call {
  width: 100%;
  background-image: url(../assets/img/back/back_call.webp);
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  padding: 6rem 21rem 4rem 8rem;
  justify-content: space-between;
}
.box_main_text_call {
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
}
.title_call {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: 0%;
  text-align: left;
}
.sub_title_call {
  color: rgb(245, 160, 62);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
}
.container_main_text_call {
  display: flex;
  flex-direction: column;
  gap: 7rem;
}
.container_sub_text_call {
  display: flex;
  flex-direction: column;
  gap: 4.4rem;
  width: 13.7rem;
}
.sub_text_call {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
  letter-spacing: -1%;
  text-align: left;
}
.container_check_mark_call {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.box_check_mark_call {
  display: flex;
  gap: 1.75rem;
}
.check_mark {
  width: 0.85rem;
  height: 0.75rem;
  object-fit: cover;
}
.text_check_mark {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
}
@media (max-width: 767px) {
  .section_call {
    padding: 3rem 2.4rem 0.8rem 2.4rem;
    background-image: url(../assets/img/back/back_call_m.webp);
  }
  .container_sub_text_call {
    display: none;
  }
  .container_sub_text_call_mobil {
    display: flex;

    flex-direction: column;
    gap: 2.2rem;
  }
  .title_call {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 1.64rem;
  }
  .sub_title_call {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.14rem;
  }
  .sub_text_call {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.14rem;
  }
  .text_check_mark {
    font-size: 0.71rem;
    font-weight: 400;
    line-height: 0.86rem;
  }
  .box_check_mark_call {
    gap: 0.5rem;
  }
}
</style>
